import {NgModule} from '@angular/core';
import {DcModule} from "./dc/dc.module";
import {JbModule} from "./jb/jb.module";
import {XhModule} from "./xh/xh.module";
import {XxModule} from "./xx/xx.module";
import {FeatureTechRoutingModule} from "./feature-tech.routing.module";

@NgModule({
    imports: [
        DcModule,
        JbModule,
        XhModule,
        XxModule,
        FeatureTechRoutingModule
    ],
    exports: [
        DcModule,
        JbModule,
        XhModule,
        XxModule,
    ]
})
export class FeatureTechModule {
}